import { getMeta } from './helpers';
window.axios = require('axios');

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CheckboxToggleController from './controllers/checkbox-toggle-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import DatePickerController from './controllers/date-picker-controller';
import PerkController from './controllers/perk-controller';
import LeafletController from './controllers/leaflet-maps-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import MembershipsController from './controllers/memberships-controller';
import TimetableController from './controllers/timetable-controller';
import HeaderController from './controllers/header-controller';
import ExpandableController from './controllers/expandable-controller';
import LoginController from './controllers/login-controller';
import TabController from './controllers/tab-controller';
import PaymentController from './controllers/payment-controller';
import CartSummaryController from './controllers/cart-summary-controller';
import CheckoutDebitController from './controllers/checkout-debit-controller';
import AppNotificationController from './controllers/app-notification-controller';
import PopupController from './controllers/popup-controller';

require('./misc');
require('./navigation');
require('./auth');
require('./gallery');
require('./mask');

const application = Application.start();
window.Stimulus = application;

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('checkbox-toggle', CheckboxToggleController);
application.register('cookie-bar', CookieBarController);
application.register('date-picker', DatePickerController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('perk', PerkController);
application.register('leaflet', LeafletController);
application.register('memberships', MembershipsController);
application.register('timetable', TimetableController);
application.register('header', HeaderController);
application.register('expandable', ExpandableController);
application.register('login', LoginController);
application.register('tab', TabController);
application.register("payment-controller", PaymentController);
application.register("cart-summary-controller", CartSummaryController);
application.register("checkout-debit", CheckoutDebitController);
application.register("app-notification", AppNotificationController);
application.register('popup', PopupController);
